import React, { useState, useEffect } from 'react'

import { Grid, Typography, Box } from '@mui/material';

import { CoreContext } from '../../../core/context/CoreContext';
import PageWaiting from '../../../core/components/PageWaiting';
import IconEnabled from '../../../core/components/layout/IconEnabled';
import IconDisabled from 'core/components/layout/IconDisabled';
import { useDispatch, useSelector } from 'react-redux';
import PartyListTableHeader from './PartyListTableHeader';
import PartyListTableRow from './PartyListTableRow';
import PartyFilterCriteria from '../PartyFilterCriteria'; // Add this import

export default function PartyListTable({ payload }) {

  const { showloading } = React.useContext(CoreContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const {userprofileInfo} = useSelector((state)=>state.headerslice);
  const {filterCriteria, sorting} = useSelector((state) => state.pharmaslice.partyDashboard); // Add sorting
  
  useEffect(() => {
    if (rows.length===0)
    setRows(payload.tableList);
  }, [payload])

  // Add filter effect
  useEffect(() => {
    let filteredList = payload.tableList || [];
    
    // Filter by title if filterCriteria.title exists
    if (filterCriteria.title && filterCriteria.title.trim() !== '') {
      filteredList = filteredList.filter(item => 
        item.title && item.title.toLowerCase().includes(filterCriteria.title.toLowerCase())
      );
    }
    
    // Filter by contact if filterCriteria.contact exists
    if (filterCriteria.contact && filterCriteria.contact.trim() !== '') {
      filteredList = filteredList.filter(item => 
        item.contact && item.contact.toLowerCase().includes(filterCriteria.contact.toLowerCase())
      );
    }
    
    // Filter by contactmobile if filterCriteria.contactmobile exists
    if (filterCriteria.contactmobile && filterCriteria.contactmobile.trim() !== '') {
      filteredList = filteredList.filter(item => 
        item.contactmobile && item.contactmobile.toLowerCase().includes(filterCriteria.contactmobile.toLowerCase())
      );
    }
    
    // Filter by statusname if filterCriteria.statusname exists
    if (filterCriteria.statusname && filterCriteria.statusname.trim() !== '') {
      filteredList = filteredList.filter(item => 
        item.statusname && item.statusname.toLowerCase().includes(filterCriteria.statusname.toLowerCase())
      );
    }
    
    // Filter by status if filterCriteria.status exists and is not empty string
    if (filterCriteria.status !== '') {
      filteredList = filteredList.filter(item => 
        item.status === filterCriteria.status
      );
    }
    
    setRows(filteredList);
  }, [filterCriteria, payload.tableList]);

  // Add sorting effect
  useEffect(() => {
    if (sorting.column) {
      const sortedRows = [...rows].sort((a, b) => {
        let aValue = a[sorting.column];
        let bValue = b[sorting.column];
        
        // Handle null/undefined values
        if (aValue == null) aValue = '';
        if (bValue == null) bValue = '';
        
        // Convert to string for comparison
        aValue = String(aValue).toLowerCase();
        bValue = String(bValue).toLowerCase();
        
        if (aValue < bValue) return sorting.asc ? -1 : 1;
        if (aValue > bValue) return sorting.asc ? 1 : -1;
        return 0;
      });
      setRows(sortedRows);
    }
  }, [sorting]);

  const handleRowClick = (rowId) => {
    setRows(prevData =>
      prevData.map(item =>
        item.id === rowId ? { ...item, 'expand': !item.expand } : item
      )
    );
  }

  const getActionComponent = (rowObj) => {
    return <>
      { payload.actionList.map(actionObj=>{
         if (
          (
            ( actionObj.title==="Edit" || actionObj.title==="Delete") && "PHARMA_OMS_MANAGER, PHARMA_OMS_SALES".includes(userprofileInfo.rolename) && (rowObj.statusname.toLowerCase()==="draft" || rowObj.statusname.toLowerCase()==="referred back")||
            (actionObj.title==="Edit" && (userprofileInfo.rolename==="PHARMA_OMS_MANAGER" || userprofileInfo.rolename==="PHARMA_OMS_MD" || userprofileInfo.rolename==="PHARMA_OMS_ADMIN"))
          )
          ||
          (
            (actionObj.status!==undefined && actionObj.status.toLowerCase().includes(rowObj.statusname.toLowerCase()))
            && 
            (actionObj.role!=undefined && actionObj.role.includes(userprofileInfo.rolename))
          ) 
        )
        return <IconEnabled actionObj={actionObj}  id={rowObj.id}/>})}
    </>
  }

  return (
    <>
      <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", }}>
        
        {/* Filter Criteria Section */}
        <Grid item sx={{ width: '100%', paddingBottom: 1 }}>
          <PartyFilterCriteria />
        </Grid>
        
        {/* <HEADER/> */}
        <Grid item sx={{ width: '100%', paddingBottom: .2 }}>
          {/* <HEADER - CONTAINER/> */}
          < PartyListTableHeader/>
        </Grid>
        {/* <ROWS/> */}
        <Grid item sx={{ width: '100%' }}>
          <Box lg={12} sx={{ flexGrow: 1 }}>
            <Grid item sx={{ overflowY: "scroll", backgroundColor: 'white', maxHeight: '65vh' }}>
              {/* <ROW CONTAINER/> */}
              <Grid container direction="column" sx={{ justifyContent: "flex-start", alignItems: "flex-start", width: '100%' }}>

              {rows.map(obj => {
                    return (
                      < PartyListTableRow obj={obj} getActionComponent={getActionComponent} handleRowClick={handleRowClick}/>
                    ) 
                })}
              {
                  rows.length === 0 ?
                    <Grid
                      container
                      direction="row"
                      justifyContent="center"
                      alignItems="center"
                      sx={{ width: '100%', backgroundColor: '#fafafa' }}
                      padding={1}
                    >
                      <Typography sx={{ fontWeight: 'light', fontSize: 14 }}>
                        <i>{payload.tableList && payload.tableList.length > 0 ? 'No parties match the filter criteria.' : 'Parties are not added, yet.'}</i>
                      </Typography>
                    </Grid>
                    : <></>
                }
               </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}